import SynchPayLogo2 from "../../assets/synch-pay-logo2.svg"
import ReimbursementsBlocks from "../../assets/reimbursements-blocks.svg"
import { Text } from "../../ui-components"
import ReimburseIcon from "../../assets/reimburse.svg"
import RightCaret from "../../assets/RightCaret.svg"
import { useCurrencyFormatter } from "../../hooks"
import { useReimbursementsList } from "../../api/queries"
import styled from "@emotion/native"

type ReimbursementBlockProps = {
  onPressTotalReimbursements?: () => void
}

export function ReimbursementBlock({ onPressTotalReimbursements }: ReimbursementBlockProps) {
  const { data: reimbursementData } = useReimbursementsList()
  const totalReimbursed =
    reimbursementData?.providers.reduce((acc, curr) => {
      return acc + curr.totalAmount.value
    }, 0) || 0
  const totalPotentialClaims =
    reimbursementData?.claims.reduce((acc, curr) => {
      return acc + curr.amount.value
    }, 0) || 0
  const { formatAmount } = useCurrencyFormatter()

  function renderPotentialClaims() {
    return (
      <PotentialClaimsContainer>
        {totalPotentialClaims ? (
          <TotalReimbursementsTextContainer onPress={onPressTotalReimbursements}>
            <ReimburseIcon />
            <Text fontFamily="IBMPlexSans-Medium" fontSize={14} lineHeight={22} color="spring600">
              {formatAmount({ currencyCode: "USD", value: totalPotentialClaims })} reimbursement
              ready
            </Text>
            <RightCaretContainer>
              <RightCaret />
            </RightCaretContainer>
          </TotalReimbursementsTextContainer>
        ) : (
          <NothingToReimburseTextContainer>
            <Text
              fontFamily="IBMPlexSans-Regular"
              fontSize={14}
              lineHeight={22}
              align="center"
              color="grayscale950"
            >
              Nothing to reimburse
            </Text>
          </NothingToReimburseTextContainer>
        )}
      </PotentialClaimsContainer>
    )
  }

  return (
    <ReimbursementsBlockContainer>
      <ReimbursementsBlockInnerContainer>
        <ReimbursementsBlockLeftSide>
          <SynchPayLogo2 />
          <ReimbursementsBlocks />
        </ReimbursementsBlockLeftSide>
        <ReimbursementsBlockRightSide>
          <Text fontFamily="IBMPlexSans-Medium" fontSize={32} lineHeight={38}>
            {formatAmount({ value: totalReimbursed, currencyCode: "USD" })}
          </Text>
          <Text fontFamily="IBMPlexSans-Regular" fontSize={16} lineHeight={24}>
            Total reimbursements
          </Text>
        </ReimbursementsBlockRightSide>
      </ReimbursementsBlockInnerContainer>
      {renderPotentialClaims()}
    </ReimbursementsBlockContainer>
  )
}

const PotentialClaimsContainer = styled.View`
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.homeScreen.potentialClaimsUpperBorder};
`

const NothingToReimburseTextContainer = styled.View`
  justify-content: center;
  padding-top: 16px;
`

const TotalReimbursementsTextContainer = styled.Pressable`
  flex-direction: row;
  gap: 8px;
  padding-top: 16px;
  align-items: center;
`

const RightCaretContainer = styled.View`
  flex-grow: 1;
  align-items: flex-end;
  justify-content: center;
`

const ReimbursementsBlockContainer = styled.View`
  background-color: ${({ theme }) => theme.homeScreen.reimbursementsContainer};
  border-radius: 16px;
  padding: 20px;
`

const ReimbursementsBlockInnerContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  height: 162px;
  padding-bottom: 20px;
`

const ReimbursementsBlockLeftSide = styled.View`
  justify-content: space-between;
`

const ReimbursementsBlockRightSide = styled.View`
  align-items: flex-end;
`
